import * as React from 'react';

import PLS from '../assets/pls-logo.png';

export default function PLSLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={PLS} alt='PLS logo' {...props} />;
}
